import script from "./SkewedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedModal.vue?vue&type=script&setup=true&lang=js"

import "./SkewedModal.vue?vue&type=style&index=0&id=1161f315&scoped=true&lang=scss"
import "./SkewedModal.vue?vue&type=style&index=1&id=1161f315&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1161f315"]])

export default __exports__